<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <app-notificacoes-perfis *ngIf="mensagens" [notificacaoMensagens]="mensagens" [notificacaoStatus]="statusSucesso"
                               (fecharNotificacoes)="mensagens = []">
      </app-notificacoes-perfis>
    </div>
    <div class="col-4">
      <h2>Gerenciando Usuários</h2>
    </div>
    <div class="col-4 offset-4  text-end">
      <button class="btn btn-terceary" routerLink="/perfis">
        <i class="fa fa-undo" aria-hidden="true"></i> Voltar para lista de perfis</button>
    </div>
  </div>
</div>
<div class="container">
  <div class="row">
    <div class="col-4 offset-8 ">
      <div class="input-group">
        <span class="input-group-text mr-2">Filtro:</span>
        <input type="text" class="form-control mr-2" placeholder="buscar" [(ngModel)]="filtroUsuarios">
      </div>
    </div>
  </div>
  <hr>
  <div class="row">
    <div class="col">
      <table class="table table-striped table-hover" id="tabela-usuarios">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Login</th>
            <th>Perfil</th>
            <th>Perfil App Gestão de Abastecimento</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let u of usuariosDaEntidadeFiltrados | paginate: {id: 'paginateUser',  itemsPerPage: 10, currentPage: paginaAtual };"  [id]="u.codAcesso"  >
            <td class="cssNomeEmail">
              <p>
                {{u.dscNome | uppercase}}
              </p>
              <p class="cssDscEmail">
                {{u.dscEmail | lowercase}}
              </p>
            </td>
            <td>{{u.dscLogin | uppercase}}</td>
            <td>
              <select [(ngModel)]="u.codPerfil" class="form-select" aria-label="Default select example">
                <option *ngFor="let p of lstperfis" [selected]="p.codperfil == u.codPerfil" value={{p.codperfil}}>
                  {{p.dscperfil | uppercase}}
                </option>
              </select>
            </td>
            <td>{{u.dscPerfilApp | uppercase}}</td>
            <td>{{u.dscStatus | uppercase}}</td>
            <td class="text-end">
              <button class="btn btn-terceary" data-bs-toggle="modal" data-bs-target="#modificar-usuario"
                (click)="setUsuario(u, 'modificar')">
                <i class="fa fa-check" aria-hidden="true"></i> Salvar</button>
              <button *ngIf="(u.dscStatus | uppercase) == 'ATIVO'" class="btn btn-secondary" data-bs-toggle="modal"
                data-bs-target="#modificar-usuario" (click)="setUsuario(u, 'desativar')">
                <i class="fa fa-lock" aria-hidden="true"></i>Inativar</button>
              <button *ngIf="(u.dscStatus | uppercase) == 'INATIVO'" class="btn btn-secondary" data-bs-toggle="modal"
                data-bs-target="#modificar-usuario" (click)="setUsuario(u, 'ativar')">
                <i class="fa fa-unlock" aria-hidden="true"></i>Ativar</button>
            </td>



          </tr>
          <tr *ngIf="usuariosDaEntidadeFiltrados.length == 0">
            <td colspan="6">
              <strong>
                Nenhum usuário encontrado
              </strong>
            </td>
          </tr>
        </tbody>
        <tfoot *ngIf="usuariosDaEntidadeFiltrados.length > 0">
          <tr>
            <th colspan="4">
              <pagination-controls id="paginateUser" nextLabel="" previousLabel=""
                (pageChange)="paginaAtual = $event"></pagination-controls>

            </th>
            <th colspan="2" class="text-end">
              <button (click)="exportUsuariosToExcel('tabela-usuarios', 'Lista-usuarios')" class="btn btn-info"><i
                  class="fa fa-file-excel-o"></i> Exportar para
                excel</button>
            </th>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>
<div class="modal fade" id="modificar-usuario" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="modificar-usuarioLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="modificar-usuarioLabel" *ngIf="(tipoModificacao | uppercase) == 'MODIFICAR'">
          Alterar Perfil do Usuário</h1>
        <h1 class="modal-title fs-5" id="desativar-usuarioLabel" *ngIf="(tipoModificacao | uppercase) != 'MODIFICAR'">
          {{(_usuario.dscStatus | uppercase) == 'INATIVO' ? 'Ativar': 'Inativar' }} Usuário</h1>

        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body ">

        <div class="row">
          <div class="col-3">
            <div class="form-group">
              <label for="dscLogin">Login</label>
              <input id="dscLogin" type="text" [value]="_usuario.dscLogin" class="form-control" disabled>
            </div>
          </div>
          <div class="col-5">
            <div class="form-group">
              <label for="dscNome">Nome Completo</label>
              <input id="dscNome" type="text" [value]="_usuario.dscNome" class="form-control" disabled>

            </div>
          </div>

          <div class="col-4">
            <div class="form-group">
              <label  for="dscEmail">E-mail</label>
              <input id="dscEmail" type="email" [value]="_usuario.dscEmail" class="form-control" disabled>

            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label for="datNascimento">Data de Nascimento</label>
              <input id="datNascimento" type="date" [value]="_usuario.datNascimento | date: 'yyyy-MM-dd'" class="form-control" disabled>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <label for="numDddFone">DDD</label>
              <input id="numDddFone" type="text" [value]="_usuario.numDddFone " class="form-control" disabled>

            </div>
          </div>
          <div class="col-5">
            <div class="form-group">
              <label for="numFone">Telefone</label>
              <input id="numFone" type="tel" [value]="_usuario.numFone" class="form-control" disabled>

            </div>
          </div>

        </div>


        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label for="dscIdentificacao">CPF</label>
              <input id="dscIdentificacao" type="text" [value]="_usuario.dscIdentificacao | formatcpf" class="form-control" disabled>

            </div>
          </div>

          <div class="col-3">
            <div class="form-group">
              <label for="dscPerfil">Perfil</label>
              <input id="dscPerfil" type="text" [value]="_usuario.dscPerfil" class="form-control" disabled>

            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <label for="dscPerfilApp">Perfil App Gestão de Abastecimento</label>
              <input id="dscPerfilApp" type="text" [value]="_usuario.dscPerfilApp" class="form-control" disabled>

            </div>
          </div>
        </div>
        <div class="row" *ngIf="(tipoModificacao | uppercase) == 'MODIFICAR'">
          <div class="col cssAvisoAlteracao">
            <p>Perfil aterado de: <strong>{{dscPerfilAntigo | uppercase}}</strong> para <strong>{{_usuario.dscPerfil |
                uppercase}}</strong></p>
          </div>
        </div>



      </div>
      <div class="modal-footer">
        <button type="button" id="btnCancelarAlteracaoPerfil" class="btn btn-secondary"
          data-bs-dismiss="modal">Cancelar</button>
        <button class="btn btn-terceary"
        *ngIf="(tipoModificacao | uppercase) == 'MODIFICAR'"
        (click)="modificarUsuario()">
          <i class="fa fa-check" aria-hidden="true"></i> Salvar Alteracão de Perfil
        </button>

        <button class="btn btn-terceary"
        *ngIf="(tipoModificacao | uppercase) != 'MODIFICAR'"
        (click)="modificarUsuario()"
        >
          <i class="fa fa-check" aria-hidden="true"></i> {{(_usuario.dscStatus | uppercase) == 'INATIVO' ? 'Ativar ':
          'Inativar' }} Usuário</button>
      </div>
    </div>
  </div>
</div>

